import { css } from 'styled-components';

import { Colors } from './ui';

export const richContentStyles = css`
  p {
    margin: 0 0 1.2rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 1.6rem 0 0.8rem;
    line-height: 1.3;
    font-weight: 600;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.6rem;
  }

  h4,
  h5,
  h6 {
    font-size: 1.5rem;
  }

  & > h1:first-child,
  & > h2:first-child,
  & > h3:first-child {
    margin-top: 0;
  }

  ul,
  ol {
    margin: 0 0 1.2rem;
    padding-left: 2rem;
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  li {
    margin: 0.4rem 0;
  }

  li > p {
    margin-bottom: 0.4rem;
  }

  li > p:last-child {
    margin-bottom: 0;
  }

  blockquote {
    border-left: 2px solid ${Colors.textLighter};
    margin: 1rem 1rem 1.2rem 0;
    padding-left: 1rem;
    color: ${Colors.textLighter};
  }

  pre {
    background-color: ${Colors.greyLighter};
    border-radius: 0.4rem;
    padding: 0.8rem 1.2rem;
    margin: 0 0 1.2rem;
    white-space: pre-wrap;
    word-break: break-word;
    max-width: 100%;
  }

  code {
    font-family: monospace;
    background-color: ${Colors.greyLighter};
    border-radius: 0.3rem;
    padding: 0.1rem 0.4rem;
  }

  pre code {
    background-color: transparent;
    padding: 0;
  }

  hr {
    border: none;
    border-top: 1px solid ${Colors.outline};
    margin: 1.6rem 0;
  }

  a {
    color: ${Colors.tealDark};
    text-decoration: underline;

    &:hover {
      color: ${Colors.tealDarker};
    }
  }

  mark {
    background-color: ${Colors.tealLight};
  }

  .jobTableScroll {
    overflow-x: auto;
    margin: 0.8rem 0;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
  }

  th,
  td {
    border: 0.1rem solid ${Colors.outline};
    padding: 0.4rem 0.8rem;
    text-align: left;
    vertical-align: middle;
    word-break: break-word;
  }

  th {
    background-color: ${Colors.tealLightest};
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;
